import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_LESSON,
  AddLessonAction,
  DELETE_LESSON,
  DeleteLessonAction,
  GET_LESSON,
  GetLessonAction,
  GetLessonsAction,
  UPDATE_LESSON,
  UpdateLessonAction,
  GET_LESSONS,
  GET_LESSON_DETAIL,
  GetLessonDetailAction,
  ToggleLessonStateAction,
  TOGGLE_LESSON_STATE,
  GetLessonSelectListByChapterAction,
  GET_LESSON_LIST_BY_CHAPTER,
} from "./actionTypes";
import {
  addLessonError,
  addLessonSuccess,
  deleteLessonError,
  deleteLessonSuccess,
  getLessonDetailError,
  getLessonDetailSuccess,
  getLessonError,
  getLessonSelectListByChapterError,
  getLessonSelectListByChapterSuccess,
  getLessonSuccess,
  getLessonsError,
  getLessonsSuccess,
  toggleLessonStateError,
  toggleLessonStateSuccess,
  updateLessonError,
  updateLessonSuccess,
} from "./actions";
import {
  addLesson,
  deleteLesson,
  getLesson,
  getLessons,
  getLessonDetail,
  updateLesson,
  toggleLessonState,
  getChaptersSelectListBySubject,
  getLessonSelectListByChapter,
} from "../../helpers/backend_helper";

function* getLessonsSaga({ payload: { request, history } }: GetLessonsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getLessons,
      request as PaginateQuery
    );
    yield put(getLessonsSuccess(response.data));
  } catch (error) {
    yield put(getLessonsError(error));
  }
}

function* getLessonSaga({ payload: { id, history } }: GetLessonAction) {
  try {
    const response: ResponseGenerator = yield call(getLesson, id);
    yield put(getLessonSuccess(response.data));
  } catch (error) {
    yield put(getLessonError(error));
  }
}

function* getLessonDetailSaga({
  payload: { id, history },
}: GetLessonDetailAction) {
  try {
    const response: ResponseGenerator = yield call(getLessonDetail, id);
    yield put(getLessonDetailSuccess(response.data));
  } catch (error) {
    yield put(getLessonDetailError(error));
  }
}

function* addLessonSaga({ payload: { request, history } }: AddLessonAction) {
  try {
    yield call(addLesson, request);
    yield put(addLessonSuccess());
  } catch (error) {
    yield put(addLessonError(error));
  }
}

function* updateLessonSaga({
  payload: { id, request, history },
}: UpdateLessonAction) {
  try {
    yield call(updateLesson, id, request);
    yield put(updateLessonSuccess());
  } catch (error) {
    yield put(updateLessonError(error));
  }
}

function* deleteLessonSaga({ payload: { id, history } }: DeleteLessonAction) {
  try {
    yield call(deleteLesson, id);
    yield put(deleteLessonSuccess());
  } catch (error) {
    yield put(deleteLessonError(error));
  }
}

function* toggleLessonStateSaga({
  payload: { chapterId, lessonId },
}: ToggleLessonStateAction) {
  try {
    yield call(toggleLessonState, lessonId);
    yield put(toggleLessonStateSuccess(chapterId, lessonId));
  } catch (error) {
    yield put(toggleLessonStateError(error));
  }
}

function* getLessonSelectListByChapterSaga({
  payload: { chapterId },
}: GetLessonSelectListByChapterAction) {
  try {
    const response: ResponseGenerator = yield call(
      getLessonSelectListByChapter,
      chapterId
    );
    yield put(getLessonSelectListByChapterSuccess(response.data));
  } catch (error) {
    yield put(getLessonSelectListByChapterError(error));
  }
}

function* LessonSaga() {
  yield takeEvery(GET_LESSONS, getLessonsSaga);
  yield takeEvery(GET_LESSON, getLessonSaga);
  yield takeEvery(GET_LESSON_DETAIL, getLessonDetailSaga);
  yield takeEvery(ADD_LESSON, addLessonSaga);
  yield takeEvery(UPDATE_LESSON, updateLessonSaga);
  yield takeEvery(DELETE_LESSON, deleteLessonSaga);
  yield takeEvery(TOGGLE_LESSON_STATE, toggleLessonStateSaga);
  yield takeEvery(GET_LESSON_LIST_BY_CHAPTER, getLessonSelectListByChapterSaga);
}

export default LessonSaga;
